<template>
  <footer class="tw-bg-gray-900 tw-py-20 tw-text-white">
    <k-container>
      <div class="tw-w-max-content tw-mx-auto md:tw-mx-0">
        <k-link :to="{ name: $data.$ROUTE_NAMES.HOME }">
          <k-logo class="tw-h-10 sm:tw-h-full tw-object-left" color="white" />
        </k-link>
      </div>

      <div class="tw-grid tw-grid-cols-1 tw-gap-y-12 lg:tw-grid-cols-3 xl:tw-grid-cols-2 tw-mt-12">
        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-col-span-2 xl:tw-col-span-1">
          <div>
            <p class="section-title">{{ $t('navigation.titles.it_specialists') }}</p>
            <ul class="tw-grid tw-grid-cols-2 tw-gap-y-4 tw-justify-items-center tw-list-none tw-mt-10 tw-p-0 md:tw-block md:tw-justify-items-start md:tw-space-y-4">
              <li>
                <k-link :to="{ name: $data.$ROUTE_NAMES.PROJECT_INDEX }" class="tw-text-gray-300 hover:tw-text-white">
                  {{ $t('navigation.jobs') }}
                </k-link>
              </li>
              <li>
                <k-link
                  :to="!!profile ? { name: $data.$ROUTE_NAMES.CV_SHOW, params: { id: profile.id } } : { name: $data.$ROUTE_NAMES.CV_LANDING_PAGE }"
                  class="tw-text-gray-300 hover:tw-text-white"
                >
                  {{ $t(!!profile ? 'global.my_resume' : 'global.resume') }}
                </k-link>
              </li>
              <li v-if="careerProjectId">
                <k-link
                  :to="{ name: $data.$ROUTE_NAMES.PROJECT_DETAIL, params: { id: careerProjectId } }"
                  class="tw-text-gray-300 hover:tw-text-white"
                >
                  {{ $t('navigation.carrier') }}
                </k-link>
              </li>
              <li>
                <k-link :to="{ name: $data.$ROUTE_NAMES.QUESTIONAIRE }" class="tw-text-gray-300 hover:tw-text-white">
                  {{ $t('navigation.adequate_salary') }}
                </k-link>
              </li>
              <li>
                <k-link :to="{ name: $data.$ROUTE_NAMES.CALCULATOR }" class="tw-text-gray-300 hover:tw-text-white">
                  {{ $t('navigation.calculator') }}
                </k-link>
              </li>
              <li>
                <k-link :to="{ name: $data.$ROUTE_NAMES.EVENT_INDEX }" class="tw-text-gray-300 hover:tw-text-white">
                  {{ $t('navigation.events') }}
                </k-link>
              </li>
              <li>
                <k-link :to="{ name: $data.$ROUTE_NAMES.REFERRAL }" class="tw-text-gray-300 hover:tw-text-white">
                  {{ $t('navigation.koderia_referral') }}
                </k-link>
              </li>
              <li>
                <k-link :to="{ name: $data.$ROUTE_NAMES.EXTRA }" class="tw-text-gray-300 hover:tw-text-white">
                  {{ $t('navigation.koderia_extra') }}
                </k-link>
              </li>
              <li>
                <k-link :to="{ name: $data.$ROUTE_NAMES.BLOG_INDEX }" class="tw-text-gray-300 hover:tw-text-white">
                  {{ $t('navigation.blog') }}
                </k-link>
              </li>
              <li>
                <k-link :to="{ name: $data.$ROUTE_NAMES.ABOUT_US }" class="tw-text-gray-300 hover:tw-text-white">
                  {{ $t('navigation.about_us') }}
                </k-link>
              </li>
              <li>
                <k-link
                  :to="{ name: $data.$ROUTE_NAMES.ABOUT_US, href: '#contact' }"
                  class="tw-text-gray-300 hover:tw-text-white"
                >
                  {{ $t('navigation.contact_us') }}
                </k-link>
              </li>
            </ul>
          </div>

          <div class="tw-mt-12 md:tw-mt-0">
            <p class="section-title">{{ $t('navigation.titles.companies') }}</p>
            <ul class="tw-grid tw-grid-cols-2 tw-gap-y-4 tw-justify-items-center tw-list-none tw-mt-10 tw-p-0 md:tw-block md:tw-justify-items-start md:tw-space-y-4">
              <li>
                <k-link
                  :to="{ name: $data.$ROUTE_NAMES.COMPANY_SERVICES }"
                  class="tw-text-gray-300 hover:tw-text-white"
                >
                  {{ $t('navigation.company_services') }}
                </k-link>
              </li>
              <li>
                <k-link :to="{ name: $data.$ROUTE_NAMES.COMPANY_CASES }" class="tw-text-gray-300 hover:tw-text-white">
                  {{ $t('navigation.company_cases') }}
                </k-link>
              </li>
              <li>
                <k-link
                  :to="{ name: $data.$ROUTE_NAMES.COMPANY_ABOUT_US }"
                  class="tw-text-gray-300 hover:tw-text-white"
                >
                  {{ $t('navigation.about_us') }}
                </k-link>
              </li>
              <li>
                <k-link
                  :to="{ name: $data.$ROUTE_NAMES.COMPANY_ABOUT_US }"
                  class="tw-text-gray-300 hover:tw-text-white"
                >
                  {{ $t('navigation.contact_us') }}
                </k-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2">
          <div class="tw-hidden xl:tw-block" />
          <div>
            <p class="section-title">{{ $t('navigation.titles.legal_information') }}</p>
            <ul class="tw-list-none tw-mt-10 tw-p-0 tw-space-y-4">
              <li class="tw-text-center md:tw-text-left">
                <k-link
                  :to="{ name: $data.$ROUTE_NAMES.TERMS_AND_CONDITIONS }"
                  class="tw-text-gray-300 hover:tw-text-white"
                >
                  {{ $t('navigation.privacy_policy') }}
                </k-link>
              </li>
            </ul>

            <p class="section-title tw-mt-12">{{ $t('navigation.titles.social_network') }}</p>
            <div class="tw-flex tw-items-center tw-space-x-2 tw-mt-10 tw-justify-center md:tw-justify-start">
              <a
                href="https://www.facebook.com/koderiask/"
                target="_blank"
                rel="noopener noreferrer"
                class="tw-text-white hover:tw-text-gray-300"
              >
                <k-icon name="facebook" />
              </a>

              <a
                href="https://www.linkedin.com/company/koderiask/"
                target="_blank"
                rel="noopener noreferrer"
                class="tw-text-white hover:tw-text-gray-300"
              >
                <k-icon name="linkedin" />
              </a>

              <a
                href="https://www.instagram.com/koderiask/"
                target="_blank"
                rel="noopener noreferrer"
                class="tw-text-white hover:tw-text-gray-300"
              >
                <k-icon name="instagram" />
              </a>

              <a
                href="https://open.spotify.com/playlist/09Zy7jEChx3noVIT13huH9"
                target="_blank"
                rel="noopener noreferrer"
                class="tw-text-white hover:tw-text-gray-300"
              >
                <k-icon name="spotify" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="tw-mt-8">
        <p class="section-title tw-text-center md:tw-text-right">
          Copyright &copy; {{ new Date().getFullYear() }} Objectify s.r.o.
        </p>
      </div>
    </k-container>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import { careerProjects } from '@web/projects/constants'

export default {
  name: 'k-footer',
  computed: {
    ...mapGetters({
      profile: 'USER/getUserProfile',
    }),
    careerProjectId() {
      if (careerProjects.length === 0) {
        return null
      }

      return careerProjects[0].id
    },
  },
}
</script>

<style lang="scss" scoped>
.section-title {
  font-size: 1.5rem;
  line-height: 1;

  @media screen and (max-width: $screen-mobile) {
    font-size: 1.25rem;
    text-align: center;
  }
}
</style>
